export default{
    //urlAPI : "https://localhost:7228",
    //urlAPI2 : "https://localhost:7222",
    //urlAPI2 : "https://modspectest-fsa4ducpcvhxa7eq.australiacentral-01.azurewebsites.net/API",
    //urlAPI : "https://modspec.azurewebsites.net/API",
    //urlAPI : "http://localhost:5012",    

//ESTO YA NO APLICA, ver archivos .env...
//para test usar
//npm run build:staging

    getHomeUrl(){        
        return new URL(location.href).origin;
    }
}